import { FareGroupsCompareTableQuery } from '@websky/graphql';

export const enum CompareState {
	CompareFares,
	FullFareConditions
}

export interface FareGroup {
	title: string;
	type?: string;
	isKeyOption?: boolean;
	img: string;
}

export interface Fare {
	title: string;
	serviceClass: string;
	image: string;
}

export interface Notes {
	heading: string;
	notesList: string[];
}

export interface FareGroupsHeading {
	cells: FareGroup[];
}

export type CompareTableHeader = FareGroupsCompareTableQuery['FareGroupsCompareTable']['header'];
export type CompareTableGroups = FareGroupsCompareTableQuery['FareGroupsCompareTable']['groups'];
